<template>
  <div class="date-time-picker">
    <button
      class="btn set-time is-small is-tertiary"
      @click.prevent="setNow">
      Set to Now
    </button>

    <div class="input">
      <div class="field-label">
        <label>{{label}}</label>
        <div v-if="helpText" class="field-help">
          <Sprite name="help" />
          <Tooltip class="field-helper-text" :content="helpText" />
        </div>
      </div>

      <DatePicker
        label="date"
        v-model="date"/>

      <TimePicker
        label="time"
        v-model="time"/>
    </div>

    <error :error="error"></error>
  </div>
</template>

<script>
/**
 * pad a number with leading zeros to make it a required length
 *
 * @param  {number} number - number to pad
 * @param  {number} digits - length of ouput string
 * @returns {string} `number` padded with leading zeros to length `didgets`
 */
import input from '@/mixins/input'

import Error from '@/components/Error'
import DatePicker from '@/components/forms/inputs/DatePicker'
import TimePicker from '@/components/forms/inputs/TimePicker'
import Sprite from '@/components/Sprite'
import Tooltip from '@/components/Tooltip'

function padDidgets(number, digits) {
  return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number
}

export default {
  name: 'DateTimePicker',

  props: {
    label: {
      type: String
    },

    helpText: {
      type: String
    },

    error: {
      type: String
    }
  },

  mixins: [input],

  components: {
    DatePicker,
    TimePicker,
    Sprite,
    Tooltip,
    Error
  },

  computed: {
    currentValue: {
      get() {
        if (!this.resource) {
          return ''
        }
        return this.resource.split('T')
      },

      set(newValue) {
        this.$emit('input', newValue)
      }
    },

    date: {
      get() {
        return this.currentValue[0]
      },

      set(newDate) {
        this.currentValue = newDate + 'T' + this.time
      }
    },

    time: {
      get() {
        return this.currentValue[1]
      },

      set(newTime) {
        this.currentValue = this.date + 'T' + newTime
      }
    }
  },

  methods: {
    setNow() {
      let today = new Date()
      let currentDate =
        today.getFullYear() + '-' +
        padDidgets((today.getMonth() + 1) + 0, 2) + '-' +
        padDidgets(today.getDate() + 0, 2)

      let currentTime =
        padDidgets(today.getHours() + 0, 2) + ':' +
        padDidgets(today.getMinutes() + 0, 2) + ':' +
        padDidgets(today.getSeconds() + 0, 2)

      let currentDateTime = `${currentDate}T${currentTime}`

      this.currentValue = currentDateTime
    }
  }
}
</script>

<style lang="sass">
.date-time-picker
  margin-bottom: 30px
  position: relative

  .set-time
    position: absolute
    top: 0
    right: 0
    z-index: 1

  .field-label
    margin-bottom: 20px

  .date-picker, .time-picker
    display: flex
    align-items: center

    .field-label
      margin-bottom: 0
      margin-right: 5px

    label
      font-size: 10px
</style>
